import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatCurrency(value: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value)
}

export function formatNumber(value: number, decimals = 2): string {
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value)
}

export function formatPercent(value: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'percent',
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  }).format(value)
}

export function formatDate(date: string | Date): string {
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(date))
}

export function truncateAddress(address: string, start = 6, end = 4): string {
  if (address.length <= start + end) return address
  return `${address.slice(0, start)}...${address.slice(-end)}`
}

// Alias for truncateAddress
export const shortenAddress = truncateAddress

export function getRiskColor(profile: string): string {
  const colors: Record<string, string> = {
    CONSERVATIVE: 'text-green-600',
    MODERATE: 'text-blue-600',
    AGGRESSIVE: 'text-orange-600',
    DEGEN: 'text-red-600',
    UNKNOWN: 'text-gray-600',
  }
  return colors[profile] || colors.UNKNOWN
}

export function getPnLColor(value: number): string {
  return value >= 0 ? 'text-green-600' : 'text-red-600'
}
